import type { RestangularService } from '../../common/restangular.service'
import type * as MemoManagement from '../memo-management/memo-management.component'

import { app } from '../../../app.module'

/**
 * メモカード表示用のコンポーネント
 * @class MemoCard
 */
class MemoCard {
  // メモステータス: memoShow: メモ表示; memoEdit: メモ編集
  private memoStatus: string
  private snsType: string
  private objectType: string
  private objectId: string
  // メモ対象のメモ数
  private objectMemoCount: number
  // 編集の前のメモ内容
  private memoBeforeEdit: string
  private memoData: MemoManagement.IMemoData

  constructor(
    private $scope,
    private RestangularService: RestangularService,
    private DialogService
  ) {
    // デフォルト: メモ内容を表示
    this.memoStatus = 'memoShow'
  }

  /**
   * 初期化
   */
  public $onInit() {
    this.memoBeforeEdit = this.memoData.message
  }

  /**
   * メモを削除
   */
  public deleteMemo(): void {
    // confirmを出し、再確認する
    const deleteConfirm = confirm('メモを削除してよろしいですか? この操作は取り消しできません。')

    if (deleteConfirm !== true) {
      return
    }

    const endpoint = '/memo'
    const params = {
      memoId: this.memoData.memoId,
      snsType: this.snsType,
      objectType: this.objectType,
    }
    this.RestangularService.request('DELETE', endpoint, params)
      .then(() => {
        this.memoData.showMemoFlg = 0
        this.objectMemoCount = this.objectMemoCount - 1
        this.changeMemo('delete')
        this.DialogService.showToast('メモを削除しました。', 'success-toast')
      })
      .catch(() => {
        this.DialogService.showToast('メモの削除に失敗しました。', 'error-toast')
      })
  }

  /**
   * メモを編集
   */
  public editMemo(): void {
    if (this.memoBeforeEdit === this.memoData.message) {
      this.memoStatus = 'memoShow'
      return
    }
    const endpoint = '/memo'
    const params = {
      memoId: this.memoData.memoId,
      message: this.memoData.message,
      snsType: this.snsType,
      objectType: this.objectType,
    }
    this.RestangularService.request('UPDATE', endpoint, params)
      .then(() => {
        this.memoBeforeEdit = this.memoData.message
        this.memoStatus = 'memoShow'
        this.changeMemo('edit')
        this.DialogService.showToast('メモを編集しました。', 'success-toast')
      })
      .catch(() => {
        this.DialogService.showToast('メモの編集に失敗しました。', 'error-toast')
      })
  }

  /**
   * メモ変更(編集or削除)するイベント
   */
  private changeMemo(type: string) {
    // メモ一覧をアップデート
    this.$scope.$emit('changeMemo', {
      memo: this.memoData,
      objectId: this.objectId,
      objectType: this.objectType,
      snsType: this.snsType,
      type: type,
    })
  }
}

app.component('memoCard', {
  bindings: {
    memoData: '=',
    snsType: '@',
    objectType: '@',
    objectId: '@',
    objectData: '=',
    objectMemoCount: '=',
    isLast: '<',
    showObjectDataFlg: '<',
  },
  template: require('./memo-card.pug')(),
  controller: MemoCard,
})
